module.exports = __webpack_public_path__ + "img/batteryDetectBg1Ru.51829517.png";